"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12.688 3c-.889 0-1.433.583-1.711 1.03a3.21 3.21 0 0 0-.376.884v.001c-.01.041-.039.155-.039.27v1.708c-.019 1.077-.114 1.52-.285 1.792-.15.237-.424.446-1.18.772H4.782c-.468 0-.85.2-1.12.503-.25.28-.39.625-.474.931-.169.612-.187 1.33-.187 1.826v5.74C3 19.83 4.077 21 5.469 21H7.53c.802 0 1.502-.392 1.95-.983a4.997 4.997 0 0 0 1.488.266h6.31c1.098 0 2.064-.77 2.292-1.848.067-.317.071-.639.016-.948a2.387 2.387 0 0 0 .687-2.152 2.386 2.386 0 0 0 .726-1.72 2.39 2.39 0 0 0-.288-1.143 2.6 2.6 0 0 0 .277-1.422c-.115-1.306-1.232-2.31-2.54-2.31h-3.256c.161-.65.307-1.426.307-2.12 0-.979-.395-1.856-.896-2.486a3.578 3.578 0 0 0-.855-.786C13.45 3.156 13.08 3 12.687 3Zm-.626 3.907V5.252c.007-.023.016-.055.03-.093.034-.1.087-.222.158-.336.151-.244.295-.323.437-.323.002 0 .024.001.069.017.047.017.11.046.185.094.152.097.325.251.49.457.33.417.569.974.569 1.552 0 .856-.303 1.98-.512 2.643l-.308.976h5.27a1.054 1.054 0 0 1 .788 1.752l-.452.516.474.496a.88.88 0 0 1 .24.611c0 .347-.19.636-.448.772l-.639.336.312.652a.902.902 0 0 1 .087.392c0 .347-.19.637-.447.772l-.64.336.312.652a.934.934 0 0 1 .067.599.845.845 0 0 1-.825.658h-6.31c-.3 0-.798-.093-1.219-.265v-7.71c.765-.331 1.398-.692 1.796-1.323.421-.669.498-1.518.516-2.572v-.006Zm-3.812 4.05H4.782l-.002.002c-.033.037-.092.134-.147.332-.11.396-.133.933-.133 1.426v5.74c0 .605.465 1.043.969 1.043H7.53a.944.944 0 0 0 .719-.345v-8.199Z",
    clipRule: "evenodd"
  })]
});